module.exports = __webpack_public_path__ + "img/es.36938bbe.svg";